import { LoadFreespinCommand } from "slotworks/commands/comms/load-freespin-command";
import { StartSpinCommand } from "slotworks/commands/comms/start-spin-command";
import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import State from "slotworks/state-machine/states/state";
import { parallel } from "slotworks/utils/race-utils";
import RequestSpin from "./request-spin";

export default class RequestFreespin extends State {
    private skipping: boolean;

    public onEnter(cascadeSkip?: boolean) {

        this.skipping = cascadeSkip;

        Components.footer.showFreespinStart();

        parallel([
            () => StartSpinCommand(),
            () => LoadFreespinCommand()
        ]).then(() => {
            GameState.getCurrentGame().latestRecord();

            if (this.skipping) {
                this.skip();
            } else {
                this.complete();

            }
        });
    }

    public onSkip() {
        this.skipping = true;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/states/request-freespin.ts